import * as Sentry from "@sentry/react";

// Sentry включается, только если при сборке задан VITE_SENTRY_DSN.
export const initSentry = (): void => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    return;
  }
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
  });
};
